import { render, staticRenderFns } from "./Desentranhamento.vue?vue&type=template&id=a3c14b70&scoped=true"
import script from "./Desentranhamento.vue?vue&type=script&lang=js"
export * from "./Desentranhamento.vue?vue&type=script&lang=js"
import style0 from "./Desentranhamento.vue?vue&type=style&index=0&id=a3c14b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c14b70",
  null
  
)

export default component.exports